/**
 * "The server just told us consent is owed", carried from the stream hook to
 * the widget that can show the panel.
 *
 * WHY NOT A RELOAD, which is what this replaced. The refusal reaches
 * `useAgentStream` mid-conversation - a consent that stopped counting because
 * the disclosed set moved. The first version answered it with
 * `window.location.reload()`, on the reasoning that the consent answer lives in
 * the server component and reloading re-runs it.
 *
 * That is true and it is not worth what it costs. A reload throws away whatever
 * the learner had typed, the message they just sent, and their place in the
 * page - to reach a panel the widget can already render from local state it
 * owns. The comment beside the refusal check in that same file argues against
 * exactly this, one branch over: a reload turns a failed request into a lost
 * draft. It was right about the non-refusal case and I did it anyway on the
 * refusal case.
 *
 * A MODULE-LEVEL STORE RATHER THAN CONTEXT, mirroring the native spend gate
 * (`useSpendGate.ts`) which solves the same shape: something deep in the fetch
 * layer learns a fact that a component far away has to render, with no prop
 * path between them.
 *
 * IT ONLY EVER SETS THE FLAG. Clearing it is the panel's job, on a successful
 * write, because only the server can say the consent now counts.
 */

let required = false;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

/** Called from the fetch layer when a route answers `AI_CONSENT_REQUIRED`. */
export function recordConsentRequired(): void {
  if (required) return;
  required = true;
  emit();
}

/** Called by the panel once the server has accepted a fresh consent. */
export function clearConsentRequired(): void {
  if (!required) return;
  required = false;
  emit();
}

export function subscribeConsentRequired(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function readConsentRequired(): boolean {
  return required;
}
